import http from "./Http";

const getAll = async () => {
    const res = await http.get(`/subscriptions`);
    return res.data;
};

const getById = async (id) => {
    const res = await http.get(`/subscriptions/${id}`);
    return res.data;
};

const post = async (data) => {
    const res = await http.post("/subscriptions", data);
    return res.data;
};

const put = async (id, data) => {
    const res = await http.put(`/subscriptions/${id}`, data);
    return res.data;
};

const del = async (id) => {
    const res = await http.delete(`/subscriptions/${id}`);
    return res.data;
};

const SubscriptionService = {
    getAll,
    getById,
    post,
    put,
    del,
};

export default SubscriptionService;
